<template>
    <span>
        <!-- DESKTOP -->
        <div class="row d-md-flex d-none">
            <div class="col-3">
                <a class="btn btn-block btn-sm btn-outline-secondary" :href="returnUrl">{{ text.backToUserAccount }}</a>
            </div>
            <div class="col-3">
                <button v-show="!showResults && showSubmit" :disabled="running" :class="'btn btn-sm ' + mainButtonClass" type=submit>
                {{ text.simulateRefund }}&nbsp;<b-spinner small variant="light" v-show="running" label="Spinning"></b-spinner>
                </button>
            </div>
            <div class="col-6 text-right">
                <a href="#" v-show="showResults" @click="InitForm" :class="'btn btn-sm ' + mainButtonClass">
                    {{ text.newSimulation }}
                </a>
                <a href="#" v-show="showResults" @click="BackToForm" class="btn btn-sm btn-outline-secondary">
                    {{ text.modifyForm }}
                </a>
            </div>
        </div>
        <!-- MOBILE -->
        <div class="row d-flex d-md-none">
            <div v-show="showResults" class="col-6 text-left">
                <a href="#" @click="InitForm" :class="'btn btn-sm ' + mainButtonClass">
                    {{ text.newSimulation }}
                </a>
            </div>
            <div v-show="showResults" class="col-6 text-right">
                <a href="#" @click="BackToForm" class="btn btn-sm btn-outline-secondary">
                    {{ text.modifyForm }}
                </a>
            </div>
            <div class="col-12 text-center">
                <button v-show="!showResults && showSubmit" :disabled="running" :class="'btn btn-block btn-sm ' + mainButtonClass" type=submit>
                    {{ text.simulateRefund }}&nbsp;<b-spinner small variant="light" v-show="running" label="Spinning"></b-spinner>
                </button>
                <br>
            </div>
            <div class="col-12 text-center">
                <a class="btn btn-block btn-sm btn-outline-secondary" :href="returnUrl">{{ text.backToUserAccount }}</a>
            </div>
        </div>
    </span>
</template>

<script>
import resources from '../helpers/resources'
import Branding from '../helpers/branding'

export default {
    data() { return { text : resources } },
    props: {
        showSubmit: {
            required: false,
            type: Boolean,
            default: true
        }
    },
    computed:{
        running () { return this.$store.getters.appRunning },
        showResults () { return this.$store.getters.showResults },
        mainButtonClass () { return Branding.getMainButtonClass() },
        returnUrl() { return Branding.portalUrl() }
    },
    methods:{
        BackToForm() {
            this.$store.dispatch('backToSimulation')
        },
        InitForm() {
            this.$store.dispatch('backToSimulation')
            return this.$emit('resetForm')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Actions.vue